import { Database, DBInterpretedFields, DeserializedServer as Server, InterpretedDatabase, InterpretedServer } from '@amzn/awscat-portfolio-assessment-types';

// TODO: Change out this logic when we move over the BuildGridService
export function buildColumnDefinition(
    definition: Partial<InterpretedServer<Server>> | InterpretedDatabase<Database>,
    items: Array<InterpretedServer<Server>> | Array<InterpretedDatabase<Database>>,
    attributesToExclude: Array<keyof InterpretedServer<Server>> | Array<keyof InterpretedDatabase<Database>>,
) {
    const filterAttributesToExclude = (attributes: string) =>
        !attributesToExclude.includes(attributes as (keyof (InterpretedServer<Server> | InterpretedDatabase<Database>)));
    return Object.keys(definition)
        .filter(filterAttributesToExclude)
        .map((columnName: string) => {
            const col = columnName as keyof (InterpretedServer<Server> | InterpretedDatabase<Database> | DBInterpretedFields);
            const def = definition[col] as any;
            items.forEach((item: InterpretedServer<Server> | InterpretedDatabase<Database>) => {
                if (item[col] || item.interpretedFields?.[col]) {
                    def.hidden = false;
                }
            });
            if (!def.hidden) {
                delete def.hidden;
                return def;
            }
            return null;
        })
        .filter(col => !!col);
}
